import React from 'react';
import TinyBiweekly from 'views/tiny/TinyBiweekly.js';

function TinyBiweeklyContainer() {
  return <TinyBiweekly />;
}

export default TinyBiweeklyContainer;


